
import Vue from "vue";
import { services } from "@/core";
import { PropType } from "vue";

export default Vue.extend({
  name: "UserCredentialList",
  props: {
    crms: {
      type: Array as PropType<any[]>,
      required: true,
    },
  },
  data() {
    return {
      loadingItemId: null,
      columns: [
        { name: "Número" },
        { name: "UF" },
        { name: "Validado" },
        { name: "Tipo" },
        { name: "Ações" },
      ],
    };
  },
  methods: {
    toggleValid(item, index) {
      this.loadingItemId = item.id;
      this.$eventBus.$emit("showConfirmationAlert", {
        title: item.valid ? "Invalidar CRM" : "Validar CRM",
        message: item.valid
          ? "Deseja invalidar este CRM?"
          : "Deseja validar este CRM?",
        confirmCallback: async () => {
          try {
            await services.userService.updateCRM(item.id, {
              valid: !item.valid,
            });
            this.$eventBus.$emit("showToast", {
              title: item.valid ? "CRM invalidado" : "CRM validado",
              msg: item.valid
                ? `CRM invalidado com sucesso`
                : "CRM validado com sucesso",
            });
            this.$emit("onUpdated");
          } catch (e) {
            console.log(e);
          }
          this.loadingItemId = null;
        },
      });
    },
  },
});
